'use client'

import { useEffect, useState, useRef } from 'react';
import styles from '../styles/PurchaseFlow.module.css';
import { ConnectButton } from './ConnectButton';
import { useAppKitAccount } from '@reown/appkit/react';

interface ConnectWalletStepProps {
  onNext: () => void;
}

export const ConnectWalletStep = ({ onNext }: ConnectWalletStepProps) => {
  const { isConnected, address } = useAppKitAccount();
  // Ref to track if we've already called onNext for this connection event
  const hasNavigated = useRef(false); 
  
  useEffect(() => {
    console.log('ConnectWalletStep: Wallet connection state:', { isConnected, address });
    
    if (isConnected && address && !hasNavigated.current) {
      console.log('ConnectWalletStep: Wallet is connected, proceeding to next step');
      hasNavigated.current = true; // Mark as navigated
      
      // Add a small delay to ensure the UI updates properly before navigation
      const timer = setTimeout(() => {
        onNext();
      }, 100); // Keep the short delay
      
      return () => clearTimeout(timer); // Cleanup timer on unmount or re-run
    } else if (!isConnected && !address) {
      // Reset the navigation flag if the wallet disconnects
      hasNavigated.current = false;
      console.log('ConnectWalletStep: Wallet disconnected, reset navigation flag.');
    }
  }, [isConnected, address, onNext]);
  
  // Keep handleContinue for explicit user action
  const handleContinue = () => {
    if (isConnected && address) {
      console.log('ConnectWalletStep: Manual continue clicked');
      onNext();
    } else {
      console.log('ConnectWalletStep: Manual continue clicked, but wallet not connected.');
      // Optionally open the wallet modal here if desired
      // open(); 
    }
  };
  
  return (
    <div className={styles.walletStep}>
      <h3>{isConnected ? 'Wallet Connected' : 'Connect Your Wallet'}</h3>
      
      {!isConnected && (
        <p>Connect your wallet to start the token purchase process.</p>
      )}
      
      <div className={styles.walletConnectionArea}>
        <ConnectButton />
      </div>
      
      {/* Always show the continue button, but potentially disabled or acting as connect */} 
      {/* OR keep it only for connected state? Let's keep it simple for now: only show when connected */}
      {isConnected && address && (
        <button 
          className={styles.button}
          onClick={handleContinue}
        >
          Continue
        </button>
      )}
    </div>
  );
}; 